/* __next_internal_client_entry_do_not_use__ isAmplitudeEnabled,initAmplitude,trackEvent,trackPageView,identifyAmplitudeUser,resetAmplitudeUser auto */ import * as amplitude from "@amplitude/analytics-browser";
const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;
const apiKey = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY;
var _process_env_NEXT_PUBLIC_AMPLITUDE_ENVIRONMENTS;
const enabledEnvironments = ((_process_env_NEXT_PUBLIC_AMPLITUDE_ENVIRONMENTS = process.env.NEXT_PUBLIC_AMPLITUDE_ENVIRONMENTS) !== null && _process_env_NEXT_PUBLIC_AMPLITUDE_ENVIRONMENTS !== void 0 ? _process_env_NEXT_PUBLIC_AMPLITUDE_ENVIRONMENTS : "").split(",").map((value)=>value.trim()).filter(Boolean);
export const isAmplitudeEnabled = Boolean(apiKey) && typeof environment === "string" && enabledEnvironments.includes(environment);
let initialized = false;
export function initAmplitude() {
    if (!isAmplitudeEnabled || initialized || "object" === "undefined" || !apiKey) {
        return;
    }
    amplitude.init(apiKey, {
        // Keep volume low for the Amplitude free tier (10K MTUs / 2M events).
        autocapture: {
            sessions: true,
            pageViews: false,
            formInteractions: false,
            fileDownloads: false,
            elementInteractions: false,
            attribution: false
        },
        flushIntervalMillis: 10000,
        flushQueueSize: 30,
        serverZone: "EU"
    });
    initialized = true;
}
export function trackEvent(eventName, eventProperties) {
    if (!isAmplitudeEnabled) return;
    amplitude.track(eventName, eventProperties);
}
export function trackPageView(path) {
    if (!isAmplitudeEnabled) return;
    trackEvent("Page Viewed", {
        path,
        environment
    });
}
export function identifyAmplitudeUser(userId, userProperties) {
    if (!isAmplitudeEnabled) return;
    amplitude.setUserId(userId);
    if (userProperties && Object.keys(userProperties).length > 0) {
        const identify = new amplitude.Identify();
        Object.entries(userProperties).forEach((param)=>{
            let [key, value] = param;
            identify.set(key, value);
        });
        amplitude.identify(identify);
    }
}
export function resetAmplitudeUser() {
    if (!isAmplitudeEnabled) return;
    amplitude.reset();
}
